export default {
    lang: 'zh_TW',
    Popconfirm: {
        ok: '確定',
        cancel: '取消'
    },
    Table: {
        'resetSettings': '還原設置',
        'include': '包含',
        'exclusive': '不包含',
        'equal': '等於',
        'unequal': '不等於',
        'begin': '以開始',
        'end': '以結尾',
        'greater_than': '大於',
        'great_than_equal_to': '大於等於',
        'less_than': '小於',
        'less_than_equal to': '小於等於',
        'be_equal_to': '等於',
        'not_equal_to': '不等於',
        "no_data": '暫無數據',
    },
    Clipboard: {
        'copy': '複製',
        'cut': '剪切',
        'copyReady': '已複製',
        'cutReady': '已剪切',
        'copyToClipboard': '複製到剪切板',
        'close': '關閉',
    },
    Pagination: {
        'total': '共',
        'items': '條',
        'show': '顯示',
        'goto': '跳至',
        'page': '頁',
        'ok': '確定'
    },
    Grid: {
        'fixTitle': '鎖定',
        'noFixTitle': '解鎖',
        'hideTitle': '隱藏',
        'rowFilter': '行過濾',
        'openRowFilter': '打開行過濾',
        'closeRowFilter': '關閉行過濾',
    },
    SearchPanel: {
        'title': '默認篩選',
        'resetName': '清空',
        'searchName': '查詢',
        'down': '展開',
        'up': '收起',
    },
    InputNumber: {
        'msgMax': '值不能大於最大值',
        'msgMin': '值不能小於最小值'
    },
    Modal: {
        'gotit': '知道了',
        'cancel': '取消',
        'ok': '確定'
    },
    Loading: {
        'loading': '加載中...',
    },
    Upload: {
        'remove': '移除文件',
        'down': '下載文件',
        'fileLoading': '文件上傳中',
    }
}
